import { gapi } from "gapi-script"
import axios from 'axios';
import { setCookie } from "../helper/cookieFunction";
declare global {
  interface Window {
    gapi: any;
  }
}
var CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID
var CLIENT_SECRET = process.env.REACT_APP_GOOGLE_CLIENT_SECRET


export const GoogleCalandarEvent = (event: any,googleAccessToken:any,calandarId:any,alertMessageState:any) => {
  function initiate() {

    gapi.client
      .request({
        path: `https://www.googleapis.com/calendar/v3/calendars/${calandarId}/events`,
        method: "POST",
        body: event,
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${googleAccessToken}`,
        },
      })
      .then(
        (response: any) => {
          if(response?.status == 200){
            if (response?.result) {
              alertMessageState({
                type: "success",
                show: true,
                message: "Event Added to Calandar",
              });
            }
          }else{
            alertMessageState({
              type: "error",
              show: true,
              message: "Something Went Wrong. Please Try Again",
            });
          }
          return [true, response];
        },
        function (err: any) {
          console.error(err);
          return [false, err];
        }
      ).catch((error:any)=> console.log(error));
  }
  gapi.load("client", initiate);
}


export async function handleGoogle(setgoogleAccessToken: any,setcalandarId:any,alertMessageState:any) {
  const SCOPES = 'https://www.googleapis.com/auth/calendar.events';
  const client = window.google.accounts.oauth2.initCodeClient({
    client_id: CLIENT_ID,
    scope: SCOPES,
    ux_mode: 'popup',
    callback: async (response: any) => {
      try {
        if (!response.code) {
          return;
        }

        const requestBody = {
          grant_type: "authorization_code",
          code: response.code,
          client_id: CLIENT_ID,
          client_secret: CLIENT_SECRET,
          redirect_uri: process.env.REACT_APP_BOOKING_URL
        };

        const access_response = await axios.post('https://oauth2.googleapis.com/token', requestBody, {
          headers: {
            'Content-Type': 'application/json'
          }
        });

        setCookie("googleAccessToken","hello",365);
        if(access_response.status == 200){
          if (access_response.data) {
            setCookie("googleAccessToken",access_response?.data?.access_token,365);
            handleEmail(access_response?.data?.access_token,setcalandarId,alertMessageState)
            setgoogleAccessToken(access_response?.data?.access_token)
          }
        }else{
          alertMessageState({
            type: "error",
            show: true,
            message: "Something Went Wrong. Please Try Again",
          });
        }
      

      } catch (error) {
        console.error(error);
      }
    }
  });
  client.requestCode();
}

const handleEmail = async (accessToken:any,setcalandarId:any,alertMessageState:any) => {
  try {
    const emailResponse = await axios.get('https://www.googleapis.com/oauth2/v2/userinfo', {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });
    if(emailResponse?.status == 200){
      if (emailResponse?.data?.email) {
        setcalandarId(emailResponse?.data?.email)
      }
    }else{
      alertMessageState({
        type: "error",
        show: true,
        message: "Something Went Wrong. Please Try Again",
      });
    }
  } catch (error) {
    console.error('Error fetching user email:', error);
  }
};

